import React from "react"
import { useLocation } from "react-router-dom"
import { AppLink } from "../link/AppLink"
import styles from './PlaylistSong.module.css'

export const PlayListSong = ({ song }) => {
    const location = useLocation()

    return <div
        className={styles.song}
        key={song}>
        <AppLink
            to={location.pathname + '/' + song}>
            <span
                className={styles.song__title}
            >{song}</span>
            <span
                className={styles.song__time}
            >3.59</span>
        </AppLink>
    </div>
}